<template>
  <div id="app">
    <navbar :language="language" :loggedIn="loggedIn" v-if="showMenu"></navbar>
    <router-view :language="language"></router-view>
    <sectionFooter :language="language" v-if="showMenu"></sectionFooter>
  </div>
</template>

<script>
import navbar from './components/NavbarNEW'
import sectionFooter from './components/Footer'

export default {
  name: 'App',
  props: {
    language: {
      type: String
    },
    showMenu: {
      type: Boolean,
      default: true
    },
    loggedIn: {
      type: Boolean,
      default: false
    }
  },
  components: {
    navbar,
    sectionFooter
  },
  watch: {
    language: function () {
    }
  }
}
</script>

<style>

html, body, #app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: 'Roboto', sans-serif;
}

::-webkit-scrollbar {
    width: 15px;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 4px;
}

::-webkit-scrollbar-thumb {
    background: #000000;
    border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
    background: #619999;
}
</style>



// WEBPACK FOOTER //
// src/App.vue